import script from "./QuotaManagement.vue?vue&type=script&setup=true&lang=js"
export * from "./QuotaManagement.vue?vue&type=script&setup=true&lang=js"

import "./QuotaManagement.vue?vue&type=style&index=0&id=10f5b7fe&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-10f5b7fe"]])

export default __exports__